<template>
  <ol class="tw:m-0! tw:flex tw:flex-wrap tw:items-center tw:gap-1 tw:pl-0! tw:text-14 tw:text-gray-500">
    <li class="tw:flex tw:items-center">
      <RouterLink
        to="/"
        aria-label="Home"
        class="tw:inline-flex tw:items-center tw:rounded-sm tw:p-1 tw:text-gray-600! tw:no-underline! tw:hover:bg-gray-50! tw:hover:text-gray-700! tw:hover:no-underline!">
        <IconHome :size="20" />
      </RouterLink>
    </li>
    <li v-for="(crumb, i) in props.items" :key="crumb.label" class="tw:flex tw:items-center">
      <IconChevronRight class="tw:mx-1 tw:text-gray-300" :size="16" />
      <RouterLink
        :to="crumb.path"
        :class="[
          'tw:inline-flex tw:items-center tw:gap-1.5 tw:rounded tw:px-2 tw:py-1 tw:text-14 tw:text-gray-600! tw:no-underline! tw:hover:no-underline!',
          // Only the trailing (current-page) crumb is styled active. RouterLink's
          // built-in active-class matches on path prefix, which lights up every
          // ancestor crumb too — we want just the leaf.
          i === props.items.length - 1
            ? 'tw:bg-gray-100! tw:font-semibold! tw:text-gray-700!'
            : 'tw:font-medium tw:hover:bg-gray-50! tw:hover:text-gray-700!',
        ]">
        <component v-if="crumb.icon" :is="crumb.icon" :size="16" :stroke-width="2" class="tw:shrink-0" />
        {{ crumb.label }}
      </RouterLink>
    </li>
  </ol>
</template>

<script setup lang="ts">
import type { Component } from 'vue';
import { IconHome, IconChevronRight } from '@tabler/icons-vue';
import type { RouteLocationRaw } from 'vue-router';

export interface LeadBreadcrumbItem {
  label: string;
  path: RouteLocationRaw;
  /** Optional leading icon rendered before the label. */
  icon?: Component;
}

const props = defineProps<{
  items: LeadBreadcrumbItem[];
}>();
</script>
